/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable-next-line no-unused-vars */
import { Route, Routes, useLocation } from "react-router-dom";

import LandingPage from "pages/LandingPage";
import ProjectPage from "pages/ProjectPage";
import NotFoundPage from "pages/NotFoundPage";
import TeamPage from "pages/TeamPage";
import { useEffect } from "react";

import { ProjectDetailPage } from "pages/ProjectDetailPage";
import { DiscussProjectPage } from "pages/DiscussProjectPage";
import { Portfolios } from "./json/landingPageData"; // Import danh sách Portfolios

import "./assets/css/styles.css";

function App() {
  const location = useLocation();

  useEffect(() => {
    // Đặt tiêu đề động dựa trên đường dẫn
    switch (location.pathname) {
      case "/":
        document.title = "Trang chủ";
        break;
      case "/project":
        document.title = "Sản phẩm";
        break;
      case "/team":
        document.title = "Giới thiệu";
        break;
      case "/discuss-project":
        document.title = "Liên hệ";
        break;
      default:
        if (location.pathname.startsWith("/project/")) {
          // Lấy ID từ URL
          const id = location.pathname.split("/project/")[1];
          // Tìm kiếm trong danh sách Portfolios
          const portfolio = Portfolios.find((item) => item.id === id);

          if (portfolio) {
            // Đặt tiêu đề theo title của portfolio
            document.title = `${portfolio.title}`;
          } else {
            // Nếu không tìm thấy, đặt tiêu đề mặc định
            document.title = "Không tìm thấy trang";
          }
        } else {
          document.title = "Không tìm thấy trang";
        }
        break;
    }
  }, [location.pathname]);
  return (
    <>
      <Routes>
        <Route exact path="/" element={<LandingPage />} />
        <Route path="/project" element={<ProjectPage />} />
        <Route exact path="/project/:id" element={<ProjectDetailPage />} />
        <Route exact path="/team" element={<TeamPage />} />
        <Route exact path="/discuss-project" element={<DiscussProjectPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

export default App;
